import axios from "axios";
import {
	USER_CHECKING,
	USER_SUCCESS,
	USER_ERROR,
	USER_LOGOUT,
	TOKEN_CHECKING,
	TOKEN_SET_USER,
	TOKEN_VERIFIED,
	TOKEN_ERROR,
	TOKEN_EMPTY,
	USER_CLEAR_ERROR,
	SET_ROLE,
} from "./actionTypes";

export function SetRole(role) {
	return {
		type: SET_ROLE,
		payload: { role },
	};
}

// Utilities
export function clearError() {
	return { type: USER_CLEAR_ERROR };
}

// Function for registration
function userLoading() {
	return { type: USER_CHECKING };
}
function userData(id, username, email) {
	console.log("userData", id, username, email);
	return { type: USER_SUCCESS, payload: { id, username, email } };
}
function userError(err) {
	console.log("userError", err);
	return { type: USER_ERROR, payload: { err } };
}
export function logout() {
	localStorage.setItem("auth-token", "");
	return { type: USER_LOGOUT };
}

// Functions for Token
function tokenChecking() {
	return { type: TOKEN_CHECKING };
}
function tokenSetUser(id, username, email) {
	console.log("tokenSetUser", userData);
	return { type: TOKEN_SET_USER, payload: { id, username, email } };
}
function tokenVerified() {
	return { type: TOKEN_VERIFIED };
}
function tokenError(err) {
	console.log("tokenError", err);
	return { type: TOKEN_ERROR, payload: { err } };
}
function tokenEmpty(err) {
	console.log("tokenEmpty", err);
	return { type: TOKEN_EMPTY, payload: { err } };
}

export function login(login) {
	return dispatch => {
		// @route   			POST /api/users/login
		// @dessc   			Sending token to active user
		// @access  			Public
		// @parameters			{ login: { email, password } }
		// @res.data			{ token, user: { _id, username, email } } || { err }
		// @possible errors		{ err: "Missing Field" } || { err: "User doesn't exist" } || { err: "Incorrect password" }
		dispatch(userLoading());
		// axios.post("/api/log/user", login);
		axios
			.post("/api/users/login", login)
			.then(res => {
				dispatch(userData(res.data.user.id, res.data.user.username, res.data.user.email));
				localStorage.setItem("auth-token", res.data.token);
				const config = {
					headers: {
						"Content-type": "application/json",
					},
				};
				config.headers["x-auth-token"] = res.data.token;
			})
			.catch(err => dispatch(userError(err.response.data.err)));
	};
}

export function signup(signup) {
	return dispatch => {
		// @route   			POST /api/users/signup
		// @dessc   			Create new user
		// @access 				Public
		// @parameters:			{ signup: { email, password, username } }
		// @res.data:			{ token, user: { _id, username, email } } || { err }
		// @possible errors: 	{ err: "Missing Field" } || { err: "Username already exist" } || { err: "Email already exist" }

		dispatch(userLoading());
		// axios.post("/api/log/user", { email: signup.email, password: signup.password });
		axios
			.post("/api/users/signup", signup)
			.then(res => {
				dispatch(userData(res.data.user.id, res.data.user.username, res.data.user.email));
				localStorage.setItem("auth-token", res.data.token);
			})
			.catch(err => dispatch(userError(err.response.data.err)));
	};
}

export function tokenPayload() {
	return dispatch => {
		// token: "<token>"
		// res.data: { user: { _id, username, email } } || { err }
		// Possible errors:  { err: "Authorization denied, Invalid token" } || { err: "Authorization denied, No token" }
		const token = localStorage.getItem("auth-token");
		dispatch(tokenChecking());
		axios
			.get("/api/users/data", { headers: { "x-auth-token": token } })
			.then(res => dispatch(tokenSetUser(res.data.user.id, res.data.user.username, res.data.user.email)))
			.catch(err => {
				const error = err.response.data.err;
				if (error === "Authorization denied, Invalid token") dispatch(tokenError(error));
				if (error === "Authorization denied, No token") dispatch(tokenEmpty(error));
				localStorage.setItem("auth-token", "");
			});
	};
}

export function tokenValidation() {
	return dispatch => {
		// token: "<token>"
		// res.data: { validToken: true } || { err }
		// Possible errors:  { err: "Authorization denied, Invalid token" } || { err: "Authorization denied, No token" }
		const token = localStorage.getItem("auth-token");
		dispatch(tokenChecking());
		axios
			.get("/api/users/verifyToken", { headers: { "x-auth-token": token } })
			.then(res => dispatch(tokenVerified()))
			.catch(err => {
				const error = err.response.data.err;
				if (error === "Authorization denied, Invalid token") dispatch(tokenError(error));
				if (error === "Authorization denied, No token") dispatch(tokenEmpty(error));
				localStorage.setItem("auth-token", "");
			});
	};
}
